<template>
  <div>
    <div class="wrapper">
          <router-view/>
    </div>
  </div>
</template>
<script>
import { socialvue } from "../config/pluginInit"
export default {
  name: "ContentLayout",
  components: {
  },
  data () {
    return {
    }
  },
  mounted () {
    socialvue.mainIndex()
  }
}
</script>
<style>
  @import url("../assets/css/custom.css");
</style>
